import React, { useState } from 'react';

import { useQuery } from 'react-query';
import { fetchFromFirebase } from '../../hooks/fetchFromFirebase';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ActiveModels from './activeModels';

const InterestForm = ({ collection, id }) => {

    const { isLoading, isError, data, error } = useQuery(['Dealer Email', collection, id], () => fetchFromFirebase('dealerInfo', 'KD6FHhBRkM5ISPT8qTRZ'));

    let dealerEmails = [];

    if (data) {
        dealerEmails = [
            { ekthesiName: data.dealerEkthesiName, email: data.dealerEmail },
            { ekthesiName: data.dealerEkthesiNameB, email: data.dealerEmailB },
            { ekthesiName: data.dealerEkthesiNameC, email: data.dealerEmailC },
            { ekthesiName: data.dealerEkthesiNameD, email: data.dealerEmailD },
            { ekthesiName: data.dealerEkthesiNameE, email: data.dealerEmailE }
        ];
    }


    const [formState, setFormState] = useState({
        katastima: '',
        lastName: '',
        firstName: '',
        phone: '',
        model: '',
        email: '',
        remarks: '',
        privacyAccepted: false,
        loading: false
    });

    const handleSubmit = (e) => {
        e.preventDefault()

        setFormState(prevState => ({ ...prevState, loading: true }));

        const { lastName, firstName, phone, email, model, remarks, katastima } = formState;
        const [ekthesiEmail, ekthesiName] = katastima.split(",");
        let templateParams = {
            ekthesiName,
            ekthesiEmail,
            subject: 'Φόρμα Επικοινωνίας Βελμάρ',
            lastName,
            firstName,
            email,
            phone,
            model,
            remarks
        }

        const toastSubmission = toast.loading("Παρακαλώ περιμένετε...", { position: toast.POSITION.BOTTOM_RIGHT});

        fetch('/send-email', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                emailFrom: templateParams.email,
                nameFrom: `${templateParams.firstName} ${templateParams.lastName}`,
                emailTo: templateParams.ekthesiEmail,
                subject: templateParams.subject,
                text: `Ονοματεπώνυμο: ${templateParams.firstName} ${templateParams.lastName}\nEmail: ${templateParams.email}\nΤηλέφωνο Επικοινωνίας: ${templateParams.phone}\nΜοντέλο Ενδιαφέροντος: ${templateParams.model}\nΕπιθυμητό Κατάστημα: ${templateParams.ekthesiName}\nΣχόλια: ${templateParams.remarks}`,
            }),
            })
            .then((response) => response.json())
            .then((data) => {
                // console.log('Success:', data);
                toast.update(toastSubmission, { render: "Επιτυχής αποστολή", type: "success", autoClose: 5000, hideProgressBar: false, isLoading: false, position: toast.POSITION.BOTTOM_RIGHT });
                resetForm();
            })
            .catch((error) => {
                toast.update(toastSubmission, {
                    render: "Αποτυχία αποστολής",
                    type: "error",
                    autoClose: 5000,
                    hideProgressBar: false,
                    isLoading: false,
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                // console.error('Error:', error);
                setFormState(prevState => ({ ...prevState, loading: false }));
            });
    }

    const resetForm = () => {
        setFormState({
            katastima: '',
            lastName: '',
            firstName: '',
            phone: '',
            model: '',
            email: '',
            remarks: '',
            loading: false,
            success: false
        });
    }

    const handleChange = (param, e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        setFormState(prevState => ({ ...prevState, [param]: value }));
    }

    return (
        <div id="dealer-section" className='interest-section blue-bg padding-vert-80'>
            <div className='container'>
                <div className='row'>
                    <div className='col m6 s12'>
                        <div className='fs-3vw lh-3vw fw-900 white'>Ενδιαφέρεστε να αποκτήσετε ένα Hyundai;</div>
                        <div className='white margin-top-20 margin-bottom-40'>Γνωρίστε και οδηγήστε όλα τα μοντέλα της Hyundai</div>
                    </div>
                    <div className='col m6 s12'>
                        <div className='row interest-form white-bg'>
                            <form onSubmit = { handleSubmit }>
                                <div className='col m6 s12 padding-vert-10'>
                                    <p className='form-label blue'>Επώνυμο</p>
                                    <input
                                        type='text'
                                        name='lastName'
                                        value={formState.lastName}
                                        onChange={handleChange.bind(this, 'lastName')}
                                        required
                                    />
                                </div>
                                <div className='col m6 s12 padding-vert-10'>
                                    <p className='form-label blue'>Όνομα</p>
                                    <input
                                        type='text'
                                        name='firstName'
                                        value={formState.firstName}
                                        onChange={handleChange.bind(this, 'firstName')}
                                        required
                                    />
                                </div>
                                <div className='col m6 s12 padding-vert-10'>
                                    <p className='form-label blue'>Κινητό Τηλέφωνο</p>
                                    <input
                                        type='number'
                                        name='phone'
                                        value={formState.phone}
                                        onChange={handleChange.bind(this, 'phone')}
                                        required
                                    />
                                </div>
                                <div className='col m6 s12 padding-vert-10'>
                                    <p className='form-label blue'>Email</p>
                                    <input
                                        type='email'
                                        name='email'
                                        value={formState.email}
                                        onChange={handleChange.bind(this, 'email')}
                                        required
                                    />
                                </div>
                                <div className='col s12 padding-vert-10'>
                                    <p className='form-label blue'>Ενδιαφέρομαι για το μοντέλο</p>
                                    <select
                                        name='model'
                                        value={formState.model}
                                        onChange={handleChange.bind(this, 'model')}
                                        required
                                    >
                                        <ActiveModels />
                                    </select>
                                </div>
                                <div className='col s12 padding-vert-10'>
                                    <p className='form-label blue'>Ενδιαφέρομαι για το κατάστημα</p>
                                    <select
                                        name='katastima'
                                        value={formState.katastima}
                                        onChange={handleChange.bind(this, 'katastima')}
                                        required
                                    >
                                        <option value="" disabled>Επιλέξτε Κατάστημα</option>
                                        {/* <option value="admin@anayia.gr">Μαρούσι</option>
                                        <option value="info@anayia.gr">Γλυκά Νερά</option>
                                        <option value="backups@anayia.gr">Θεσσαλονίκη – Θέρμη</option> */}
                                        {dealerEmails.map((dealer, index) => (
                                            // <option key={index} value={dealer.email}>{dealer.ekthesiName}</option>
                                            <option key={index} value={`${dealer.email},${dealer.ekthesiName}`}>{dealer.ekthesiName}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className='col s12 padding-vert-10'>
                                    <p className='form-label blue'>Σχόλια</p>
                                    <textarea 
                                        rows='4'
                                        name='remarks'
                                        value={formState.remarks}
                                        onChange={handleChange.bind(this, 'remarks')}
                                    />
                                </div>
                                <div className='col s12 padding-vert-10'>
                                    <label>
                                        <input
                                            type='checkbox'
                                            name='privacyAccepted'
                                            checked={formState.privacyAccepted}
                                            onChange={handleChange.bind(this, 'privacyAccepted')}
                                            required
                                            style={{ width: 'auto', display: 'inline-block', marginRight: '5px' }}
                                        />
                                        <span style={{ fontWeight: '300' }}>
                                            Έχω διαβάσει και αποδέχομαι την&nbsp;
                                            <a href='https://velmar.gr/politiki-aporritou/' className='blue' target='_blank' rel='noopener noreferrer'>
                                                Πολιτική απορρήτου
                                            </a>
                                        </span>
                                    </label>
                                </div>

                                <div className='col s12 ta-center padding-vert-10'>
                                    <button
                                        type='submit'
                                        disabled={!formState.privacyAccepted || formState.loading}
                                    >
                                        Υποβολή
                                    </button>
                                    {formState.loading && <p>Παρακαλώ περιμένετε...</p>}
                                    {formState.success && <p>Έχουμε λάβει το μήνυμά σας και σύντομα θα επικοινωνήσουμε μαζί σας</p>}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer autoClose={5000} />
        </div>
   );
}

export default InterestForm;